// removed by extract-text-webpack-plugin
module.exports = {"container":"container-3NlSk container-3Sdxl","title":"title-1aPB9 title-1DYMu","subhead":"subhead-Z60o6","form":"form-2kYw3","input":"input-2OsQv input-y5omh","link":"link-jtz5d link-1i3sH","errorMessage":"errorMessage-1ER4w errorMessage-blO0m"};


//////////////////
// WEBPACK FOOTER
// ./src/components/premium/_couponPage.css
// module id = 1244
// module chunks = 1